
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[theme]",
      function () {
        return require("private-next-pages/blogs/[theme]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[theme]"])
      });
    }
  